import React, { useEffect, useState } from 'react';
import Background from '../../images/Bg.png'; // Import the background image

const Profile = () => {
  const [profileData, setProfileData] = useState({ name: '', email: '', phone: '', address: '' });
  const [assessmentStatus, setAssessmentStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomerProfile = async () => {
      const email = localStorage.getItem('customerEmail');
      if (!email) {
        console.error('No email found in local storage');
        setError('No email found. Please log in again.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`https://backend.rethinkpack.com/api/allCustomers`);
        if (!response.ok) {
          setError(response.status === 404 ? 'Customer not found' : 'Error fetching profile data');
          return;
        }

        const allCustomers = await response.json();
        const customer = allCustomers.find((cust) => cust.email === email);

        if (customer) {
          setProfileData({
            name: customer.name,
            email: customer.email,
            phone: customer.phone,
            address: customer.address,
          });
          setAssessmentStatus(customer.assessmentStatus || false);
        } else {
          setError('Customer not found');
        }
      } catch (error) {
        console.error('Error fetching customer profile:', error);
        setError('Error fetching profile data');
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerProfile();
  }, []);

  if (loading) {
    return <p>Loading profile...</p>;
  }

  if (error) {
    return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
  }

  return (
    <div style={{ ...styles.profileContainer, backgroundImage: `url(${Background})` }}>
      <div style={styles.profileCard}>
        <div style={styles.profileAvatar}>
          <img
            src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxAQDw8QDxEPDhEQEA0QEA0QDQ8NDxAQFhEWFhURExUZHSggGBolGxUTITEiJSkrLi4uFx8zODMsNygtLisBCgoKDQ0NDg0NDysZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAOEA4QMBIgACEQEDEQH/xAAbAAEBAAMBAQEAAAAAAAAAAAAABAIDBQEGB//EAC4QAQABAwIEBAUEAwAAAAAAAAABAgMRBCExUWFxEkGRsSIygaHwQlKS0QXB4f/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A/cQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABqrvxHXs01aifLEfcFYgm5M+c+rEHRHOZRXMec+oLxHTqKu7dRqInjt7A3AAAAAAAAAAAAAAAAAAA13rvh78ge3LkU8fRLcuzPSOTCqc7y8VAABrqvUx5+m7RfvZ2jh7tALqb9M+frs2Oa22bs09uX9AtCJAZ27k08PTyVWrsVdJ5IiJB0RpsXs7Tx925FAAAAAAAAAAAAAAYXa/DGfRFVOZzLO9c8U9I4NagAINWprxT32bUusneI6fnsCcAAAFekr2mOXs3otLPxR1ytAAAiVtm54o6xxRMrdeJz+YBePInL1FAAAAAAAAAAGrUV4p77NqTVVfFjkDSAqAACTV/N9I95VptZTwn6fn3BMAAADZp/mj6+y5JpKd5nlCsAAAAFWlr2xy9m9FYqxVHXZaigAAAAAAAAACC5Oap7yvc4ABUAAGNyjMTDIBzpjG0vF16zFXSeaWqxVHlntuDWNlNmqfKfrsos2PDvO8/aAZWLfhjrxlsAAAAACJdGHOX2/ljtHsisgAAAAAAAAAHOdFBcjEz3kGICoAAAwuXYp48eQMxHXqKp4bNc1zzn1B0BzoqnnPq2UaiqOvcFo12r0VdJ5NgAAAAC+38sdo9kDoRCK9AAAAAAAAAAR6mn4u6xp1NOYzy9gSAKgDC9c8MZ8/IGF+9jaOPskmSZeAAAAAKtPfztP0lKA6Q1ae54o34x+ZbQAAZ2ac1R6rk+ko4z9IUIoAAAAAAAAAAACG7R4Zx6dmC29b8UdfJFMKgi1Neau2yu7XiJn8y54AAAAAAAAM7VeJifXsvc1bp680x02Bte0U5nEPFentYjM8Z+wNtMYjD0EUAAAAAAAAAAAAab9nO8cfduAcXWVbxTy3lM7Wq0lNe/Cr939uVfsVUTiqO0+U/VUagAAAAAAAG7S14qxz92Fq1VVOKYz/AK7urpNFFG9XxVfaOwM7FnG8/SFAIoAAAAAAAAAAAAAAAA8qpiYxMRMcp3egIb3+NpnemfD0neEVzRXKf05607/9dsB87MY47d9nj6KYzx3YTYo/bT/GAcAh34sUfsp/jDOKYjhER2jAOJb0lyrhTMdZ+FZZ/wAZH65z0jaPV0AGNuiKYxTERHKGQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//2Q=="
            alt="Profile Avatar"
            style={styles.profileImage}
          />
          <h2>{profileData.name}</h2>
        </div>
        <div style={styles.profileDetails}>
          <p><strong>Email:</strong> {profileData.email}</p>
          <p><strong>Phone:</strong> {profileData.phone}</p>
          <p><strong>Address:</strong> {profileData.address}</p>
          <button
            onClick={() => (window.location.href = '/responses')}
            style={styles.profileReportButton}
          >
            View Report
          </button>
          <br />
          <a href="/customer-dashboard" style={styles.profileBackLink}>
            ← Back to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  profileContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundImage: `url(${Background})`,
    backgroundSize: '80% 90%', // Options: 'cover', 'contain', '100% 100%'
    backgroundPosition: 'center', // Options: 'center', 'top', 'bottom', 'left', 'right'
    backgroundRepeat: 'no-repeat', // Options: 'no-repeat', 'repeat', 'repeat-x', 'repeat-y'
    margin: 0,
    fontFamily: 'Arial, sans-serif',
  },
  profileCard: {
    background: '#dfffd6', // Light green background
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    width: '550px',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
  },
  profileAvatar: {
    marginRight: '20px',
    textAlign: 'center',
    flexShrink: 0,
  },
  profileImage: {
    borderRadius: '50%',
    width: '150px',
    height: '150px',
    marginBottom: '10px',
  },
  profileDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  profileReportButton: {
    backgroundColor: '#00aaff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 20px',
    cursor: 'pointer',
    marginTop: '10px',
    fontSize: '16px',
  },
  profileBackLink: {
    display: 'inline-block',
    marginTop: '10px',
    fontSize: '16px',
    textDecoration: 'none',
    color: '#00aaff',
  },
};


export default Profile;
